<div
  class="toolbar p-1"
  [ngClass]="{ 'input-width-increase': shouldCanvasChatAvailable }"
>
  <div class="input-container">
    <ng-container *ngIf="shouldCanvasChatAvailable; else askButton">
      <textarea
        #toolbarInput
        type="text"
        class="toolbar-input scrollbar-custom-scroll-style"
        placeholder="Write your query here..."
        [(ngModel)]="canvasQuery"
        (keydown.enter)="sendCanvasQuery()"
      ></textarea>
      <img
        src="../../../../assets/icons/svg/send-icon.svg"
        alt="Send"
        height="28"
        width="28"
        class="canvas-editor-action-button input-send action-icon mb-2"
        (click)="sendCanvasQuery()"
        (keydown)="canvasService.onKeyDown($event)"
      />
    </ng-container>
    <ng-template #askButton>
      <button class="toolbar-input-button" (click)="setToolbarChat()">
        <img
          src="../../../../assets/icons/svg/new-chat-canvas.svg"
          alt="Drawer"
          height="21"
          width="21"
        />
        Ask EY Impact.AI
      </button>
    </ng-template>
  </div>

  <ng-container *ngIf="!shouldCanvasChatAvailable">
    <div class="toolbar-buttons">
      <button (click)="applyStyle('ft-bold')" title="Bold" class="action-icon">
        <strong>B</strong>
      </button>
      <button
        (click)="applyStyle('ft-italic')"
        title="Italic"
        class="action-icon"
      >
        <em>I</em>
      </button>
      <button
        (click)="applyStyle('ft-underline')"
        title="Underline"
        class="action-icon d-none"
      >
        <u>U</u>
      </button>
      <button
        (click)="applyStyle('ft-strike')"
        title="Strikethrough"
        class="action-icon"
      >
        <s>S</s>
      </button>
    </div>
  </ng-container>
</div>
